import client from '../httpClient';

const putStoreDivisionsApi = async (params) => {
  const result = await client.put('/division-masters/store-division-list', JSON.stringify(params));
  return result;
};

export default putStoreDivisionsApi;
